
export default {

    /**
     * 毎月返済額から借入可能額を計算する
     * 参照：
     * 住宅ローン計算式も分かる，利息計算，債務返済方法の算式
     * http://www5d.biglobe.ne.jp/Jusl/Keisanki/JTSL/Loan.html
     *
     * @param monthlyPayment 毎月返済額 単位：円（万円ではない）
     * @param kinri 金利 年利を%で指定
     * @param hensaiKikan 返済期間 年で指定（基本は50年だが、返済開始が遅いと50年より短い場合がある）
     */
    kariireKanouGaku: function(monthlyPayment, kinri, hensaiKikan) {
        // 例)
        // 毎月返済：10万円、金利：0.9%、返済期間 35年
        //
        // 100000 * ( (1 + 0.9/100/12)^(35*12) -1 ) / ( 0.9/100/12*(1+0.9/100/12)^(35*12) )
        let mp = Math.pow((1 + kinri/100/12), hensaiKikan*12); //共通金利パーツ

        return Math.round( monthlyPayment * (mp-1) / (kinri/100/12 * mp) );
    },
    kariireKanouGakuBonus: function(monthlyPayment, kinri, hensaiKikan) {
        //年 2回払いとして設定
        let mp = Math.pow((1 + kinri/100/2), hensaiKikan*2); //共通金利パーツ

        return Math.round( monthlyPayment/2 * (mp-1) / (kinri/100/2 * mp) );
    },

    rentalAmount(osumai) {
        if (!(osumai.kinri>0)) {
            return null;
        }

        let kariire = null;
        if (osumai.loan && osumai.kinri) {
            let kariireMonthly = this.kariireKanouGaku(osumai.loan*10000, osumai.kinri, osumai.kikan);
            kariire += kariireMonthly;
        }
        if (osumai.bonus && osumai.kinri) {
            let kariireBonus = this.kariireKanouGakuBonus(osumai.bonus*10000, osumai.kinri, osumai.kikan);
            // console.log(kariireBonus);
            kariire += kariireBonus;
        }
        if (kariire !== null) {
            kariire = Math.floor( kariire/ 100000) * 10; //10万円単位
        }

        return kariire;
    },

    hensaiKikan: function(age) {
        const maxYears = 50;
        let kikan = maxYears;
        if (age + maxYears > 79) {
            kikan = 79 - age; //80歳ピッタリで返済終了
        }
        return kikan;
    },

    hensaiKikanDefault: function(maxKikan) {
        return maxKikan >= 36 ? 35 : maxKikan;
    },

    han2Zen: function(str) {
        return str.replace(/[０-９]/g, function (s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
    },

    manYenToOkuYen(manYen) {

        if (isNaN(manYen)) {
            return 0;
        }

        if (manYen < 9999) {
            return manYen.toLocaleString();
        }
        let yen = String(manYen);
        let oku = yen.substr(0, yen.length-4);
        return oku+'億'+Number(yen.substr(-4)).toLocaleString();
    },

}
